import React, { FC, useState } from 'react';
import { Col, Row, Spin } from 'antd';
import { CurrentEditingBlockContext } from 'components/block/utils';
import { useEmployee } from 'hooks';
import { CertificatesBlock } from 'user/blocks/certificates-block';
import { DomainBlock } from 'user/blocks/domain-block';
import { InterestsBlock } from 'user/blocks/interests-block';
import { LanguageBlock } from 'user/blocks/languages-block';
import { PersonalInfoBlock } from 'user/blocks/personal-info-block';
import { PlatformsBlock } from 'user/blocks/platforms-block';
import { TechnologiesBlock } from 'user/blocks/technologies-block';
import styles from './styles.less';

export const MyProfile: FC = () => {
  const GUTTER_16 = 16;
  const SPAN_FULL = 24;

  const { loading } = useEmployee();

  const [currentBlock, setCurrentBlock] = useState<string | undefined>(
    undefined,
  );

  if (loading) {
    return <Spin className={styles['spinner']} />;
  }

  return (
    <CurrentEditingBlockContext.Provider
      value={{
        currentEditingBlock: currentBlock,
        setCurrentEditingBlock: setCurrentBlock,
      }}
    >
      <Row gutter={[GUTTER_16, GUTTER_16]}>
        <Col span={SPAN_FULL}>
          <PersonalInfoBlock />
        </Col>
        <Col span={SPAN_FULL}>
          <TechnologiesBlock />
        </Col>
        <Col span={SPAN_FULL}>
          <PlatformsBlock />
        </Col>
        <Col span={SPAN_FULL}>
          <DomainBlock />
        </Col>
        <Col span={SPAN_FULL}>
          <LanguageBlock />
        </Col>
        <Col span={SPAN_FULL}>
          <CertificatesBlock />
        </Col>
        <Col span={SPAN_FULL}>
          <InterestsBlock />
        </Col>
      </Row>
    </CurrentEditingBlockContext.Provider>
  );
};
